import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { ToastrService as ToastrLibService } from 'ngx-toastr';
import { Subscription, throwError } from 'rxjs';
import { KzIconsRegistryService } from '../../../kz-ui/ui/icon/kz-icons-registry.service';
import { kzIconsPhoto2 } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-photo2.icon';
import { kzIconsArrowdown } from '../../../kz-ui/ui/icon/generated-icons/kzIcons-arrowdown.icon';
import { ErrorHandlerStrategy, WebServiceOptions, } from '@adeo/ngx-kozikaza-api';
import { HttpParams } from '@angular/common/http';
import { MISC_CONST } from '../../../utils/const/misc';
import { catchError, tap } from 'rxjs/operators';
import { MediaService } from '@adeo/ngx-kozikaza-api/media';

@Component({
  selector: 'app-media-kaza',
  templateUrl: './media-kaza.component.html',
  styleUrls: ['./media-kaza.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaKazaComponent implements OnInit, OnDestroy {
  @Input() kaza: any;
  @Input() minWidth?: number;
  @Input() minHeight?: number;
  @Input() showMenu = true;
  @Output() mediasChange: EventEmitter<any> = new EventEmitter<any>(null);
  @Input() maxMedia: number;
  @Input() medias?: any;

  menuOpen = false;
  page: number;
  totalCount: number;
  type: string;
  types: any = [];
  pictures: any = [];
  loading = false;
  limit: number;
  totalItems: number;
  media: any;

  subscriptionMedias: Subscription;
  subscriptionTypes: Subscription;
  subscriptionScroll: Subscription;

  constructor(
    private readonly mediaService: MediaService,
    private readonly toastr: ToastrLibService,
    private readonly kzIconsRegistryService: KzIconsRegistryService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.kzIconsRegistryService.registerIcons([kzIconsPhoto2, kzIconsArrowdown]);
  }

  ngOnInit(): void {
    if (this.medias) {
      this.limit = this.maxMedia - this.medias.length;
    }

    // this.onScroll();
    this.loadMedias();

    if (this.showMenu) {
      this.loadMediaTypes();
    }
  }

  loadMedias(type?: string, page: number = 1): void {
    this.menuOpen = false;
    if (this.subscriptionMedias) {
      this.subscriptionMedias.unsubscribe();
    }
    const params: any = {};

    if (this.totalItems && this.totalItems === this.pictures.length && this.type === type) {
      return;
    }
    this.loading = true;

    if (this.type !== type) {
      this.pictures = [];
      this.type = type;
    } else if (this.page === page) {
      return;
    }
    if (type) {
      params.type = type;
    }

    if (this.minWidth) {
      params['width[gte]'] = this.minWidth;
    }

    if (this.minHeight) {
      params['height[gte]'] = this.minHeight;
    }

    params.kaza = (typeof this.kaza === 'string') ? this.kaza : this.kaza['@id'];
    params.page = page;
    params.itemsPerPage = MISC_CONST.NB_MEDIAS_OFFSET;

    this.page = page;

    const webServiceOptions: WebServiceOptions = {
      errorHandlerStrategy: ErrorHandlerStrategy.Ignore,
      refresh: true,
      refreshOnlyFirstLevel: true,
      query: new HttpParams({ fromObject: params} )
    };

    this.subscriptionMedias = this.mediaService.getMedias(null, webServiceOptions).pipe(
      catchError((err) => {
        this.loading = false;
        this.toastr.error($localize`:@@toast.could_not_load_medias:Could not load media`);
        return throwError(err);
      }),
      tap((data) => {
        this.loading = false;
        this.pictures = this.pictures.concat(data['hydra:member']);
        this.totalItems = data['hydra:totalItems'];
        this.cdr.detectChanges();
        if (this.pictures.length < this.totalItems) {
          this.loadMedias(this.type, this.page + 1);
        }
      }),
    ).subscribe();
  }

  loadMediaTypes(): void {
    this.subscriptionTypes = this.mediaService.getMediaType((typeof this.kaza === 'string') ? this.kaza : this.kaza['@id']).pipe(
      catchError((err) => {
        this.toastr.error($localize`:@@toast.could_not_load_media_categories:Unable to load media categories`)
        return throwError(err);
      }),
      tap((data) => {
        this.types = data;
        this.totalCount = data.reduce((a, b) => a + b.count, 0);
      }),
    ).subscribe();
  }

  onSelectMedia(media: any): void {
    if (this.media && media['@id'] === this.media.from) {
      this.media = null;
    } else {
      this.media = {
        from: media['@id']
      };
    }

    this.mediasChange.emit(media);
  }

  ngOnDestroy(): void {
    if (this.subscriptionMedias && !this.subscriptionMedias.closed) {
      this.subscriptionMedias.unsubscribe();
    }
    if (this.subscriptionTypes && !this.subscriptionTypes.closed) {
      this.subscriptionTypes.unsubscribe();
    }
    if (this.subscriptionScroll && !this.subscriptionScroll.closed) {
      this.subscriptionScroll.unsubscribe();
    }
  }
}
